import React from 'react'
import { Pane, Text } from 'evergreen-ui'

const StatusRegister_11 = ({ DataRegister }) => {
  return (
    <><Pane
    color="#ffffff"
        backgroundColor="red"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={8}
        display="flex" alignItems="center" justifyContent="center"
    >
      <Text
        color="#ffffff"
        
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
      >
        ไม่ผ่านการคัดเลือก
        {DataRegister[0].QUOTA_NAME +
          " " +
          DataRegister[0].Major1_faculty_name +
          " หลักสูตร " +
          DataRegister[0].Major1_LEVEL_OPEN_NAME +
          " " +
          DataRegister[0].Major1_MAJOR_ID +
          " : " +
          DataRegister[0].Major1_MAJOR_NAME}
      </Text>
    </Pane>
    
    <Pane
        color="#000000"
        backgroundColor="#686868"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={8}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
        จะเปิดรับสมัครรอบ 4 ตั้งแต่วันที่ 21 เมษายน 2569 - 7 มิถุนายน 2569
        </Text>
      </Pane>
    </>
   
  )
}

export default StatusRegister_11